<template>
  <div>
    <populate-form
      formTitle="店家公休日處理"
      fkey="mm01"
      ref="filterStoreForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      :validatePrompt="false"
      :parentVue="this"
      @customValueChanged="filterChanged"
    ></populate-form>
    <b-button v-if="store_id>0" @click="modalRuleShow=true">管理選取中店家的公休日規則</b-button>
    <b-table
      :items="restDays"
      :fields="fields"
    >
      <template v-slot:cell(apply_date)="row">
        {{row.item.apply_start}}{{row.item.apply_start===row.item.apply_end?'':('~'+row.item.apply_end)}}
      </template>
      <template v-slot:cell(ause_reply)="row">
        {{row.item.custom_cause}}{{row.item.approve_remark?(' 回覆：'+row.item.approve_remark):''}}
      </template>
      <template v-slot:cell(actions)="row">
        <b-button v-if="filterData.status==='wait_approve'" @click.stop="approveStoreRestdayApply(row.item,1)">確認</b-button>
        <b-button v-if="filterData.status==='wait_approve'" class="ml-1" @click.stop="approveStoreRestdayApply(row.item,0)">拒絕</b-button>
        <b-button v-if="filterData.status==='valid'" @click="showCancel(row.item)">取消公休</b-button>
      </template>
    </b-table>
    <b-modal
      id="cancelRestModal"
      ref="cancelRestModal"
      v-model="modalCancelShow" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="取消休息日"
        fkey="cr01"
        ref="cancelConfirmForm"
        populateOptionVar="cancelOptions"
        :parentVue="this"
        formDataObjVar="cancelData"
      />
    </b-modal>
    <b-modal
      id="ruleModal"
      ref="ruleModal"
      v-model="modalRuleShow" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <StoreRestDayRuleManage
        :store_id="store_id"
      />
    </b-modal>
  </div>
</template>

<script>

import StoreRestDayRuleManage from "./StoreRestDayRuleManage"

export default {
  name: 'StoreRestDayManage',
  components: {
    StoreRestDayRuleManage
  },
  data: function () {
    return {
      modalCancelShow:false,
      modalRuleShow:false,
      cancelData:{},
      cancelOptions:[
        {
          componentType:'span',
          col:12,
          placeholder:"請確認要取消此店家此日期的休息日設定恢復為營業日"
        },
        {
          componentType:'text',
          akey:'cancel_remark',
          col:12,
          placeholder:'填寫取消理由說明'
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.modalCancelShow = false}
            },
            {
              col:4,
              placeholder:'確認',
              execCallback:this.cancelStoreCustomRestDay
            },
          ]
        }
      ],
      Stores:[],
      restDays:[],
      fields:[
        {
          key:'apply_date',
          label:'公休日'
        },
        {
          key:'merchant_name',
          label:'供應商名'
        },
        {
          key:'store_name',
          label:'店家'
        },
        {
          key:'store_id',
          label:"店家id"
        },
        {
          key:'cause_reply',
          label:"理由-回應"
        },
        {
          key:"actions",
          label:'操作'
        }
      ],
      filterData: {},
      filterOptions:[
        {
          componentType:'vue-single-select',
          optionVar:'Stores',
          asyncFetchCB: this.loadStoreByKeyword,
          defaultValue:null,
          akey:'SelectedStoreItem',
          optionLabel:'select_text',
          col:4,
          placeholder:'選擇店家(輸入至少一個字的店家名稱關鍵字或SPS編號帶出選項,按Esc可清除全部關鍵字)',
        },
        {
          componentType:'date-picker',
          akey:'filter_date_s',
          col:2,
          placeholder:"篩選公休日-起",
        },
        {
          componentType:'date-picker',
          akey:'filter_date_e',
          col:2,
          placeholder:"篩選公休日-迄",
        },
        {
          componentType:'b-form-select',
          akey:'status',
          col:2,
          defaultValue:'wait_approve',
          dataOptions:[{text:'申請中',value:'wait_approve'},{text:'生效中',value:'valid'},{text:'取消紀錄',value:'dropped'}],
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:"查詢",
          execCallback:this.getStoreRestDays
        }
      ],
      store_id:0,
    }
  },
  methods: {
    approveStoreRestdayApply(item, is_ok) {
      let greeting = is_ok?"確認接受此店家申請且已更新商品頁相關設定？":"確定要回絕店家的申請？"
      this.$bus.fnShowConfirm(greeting, ()=>{
        let Param = {
          module:'store_admin',
          method:'approveStoreRestdayApply',
          apply_ids:item.ids,
          is_ok:is_ok,
          approve_remark:"(直接按同意)"
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnClosePopup()
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.getStoreRestDays()
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo("更新完成")
        },this)
      })
    },
    showCancel(item) {
      this.cancelData.cancel_remark = ""
      this.cancelData.store_id = item.merchant_store_id
      this.cancelData.to_cancel_instance_id = item.ids
      this.modalCancelShow = true
    },
    cancelStoreCustomRestDay() {
      if (!this.cancelData.cancel_remark) {
        this.$refs.cancelConfirmForm.triggerAlert("請填寫理由一下")
        return
      }
      let Param = {
        module:'store_admin',
        method:'cancelStoreCustomRestDay',
        store_id:this.cancelData.store_id,
        to_cancel_instance_id:this.cancelData.to_cancel_instance_id,
        cancel_remark:this.cancelData.cancel_remark
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.getStoreRestDays()
          vm.$bus.fnShowInfo("取消成功")
          vm.modalCancelShow = false
      },this)
    },
    filterChanged(upd) {
      if (upd.key === "SelectedStoreItem") {
        this.store_id = upd.val?upd.val.id:0
      }
      this.getStoreRestDays()
    },
    getStoreRestDays() {
      //新增或保存一個店家的劃位設定
      let Param = {
        module:'store_admin',
        method:'getStoreRestDayApplys',
        filter_date_s:this.filterData.filter_date_s?this.filterData.filter_date_s:'',
        filter_date_e:this.filterData.filter_date_e?this.filterData.filter_date_e:'',
        status:this.filterData.status,
        store_id:this.store_id
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.restDays = data.data
      },this)
    },
    loadStoreByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Stores = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getStoreAutoComplete',
        'keyword':keyword,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Stores = data.data.matched_store_list
      },this)
    },
  },
  computed:{
    
  },
  created () {
    if (!this.$bus.session) {
      this.$bus.session = undefined
    }
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
